// Module
var code = `<div class="notification" id="notification"></div> `;
// Exports
export default code;